import React from 'react';

const IframeWrapper = ({ id, src, name, title }) => (
  <div className="epyt-video-wrapper mb-6">
    <iframe
      loading="lazy"
      id={id}
      data-origwidth="1080"
      data-origheight="608"
      data-relstop="1"
      src={src}
      className="__youtube_prefs__  no-lazyload"
      title={title}
      allow="autoplay; encrypted-media"
      allowFullScreen
      data-no-lazy="1"
      data-skipgform_ajax_framebjll=""
      name={name}
    />
  </div>
);

export default IframeWrapper;
